import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import SubscriptionService from 'services/SubscriptionService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
    planData: [],
    singlePlan:[],
    resData:'',
    userSubscription:[],
    
}


export const getAllPlan = createAsyncThunk('subscription/getAllPlan', async (params, { rejectWithValue }) => {
	
	try {
		const response = await SubscriptionService.getAllPlan(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});
export const getUserSubscription = createAsyncThunk('subscription/getUserSubscription', async (params, { rejectWithValue }) => {
	
	try {
		const response = await SubscriptionService.getUserSubscription(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const buySubscription = createAsyncThunk('subscription/buySubscription', async (params, { rejectWithValue }) => {
	
	try {
		const response = await SubscriptionService.buySubscription(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const cancelSubscription = createAsyncThunk('subscription/cancelSubscription', async (params, { rejectWithValue }) => {
	
	try {
		const response = await SubscriptionService.cancelSubscription(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const resumeSubscription = createAsyncThunk('subscription/resumeSubscription', async (params, { rejectWithValue }) => {
	
	try {
		const response = await SubscriptionService.resumeSubscription(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});


export const subscriptionSlice = createSlice({
    name: 'subscription',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getAllPlan.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(getAllPlan.fulfilled, (state, action) => {
            state.loading = false
            state.planData = action.payload
        })
        .addCase(getAllPlan.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getUserSubscription.pending, (state) => {
            state.loading = true
            state.message = ''
           // state.resData=''
        })
        .addCase(getUserSubscription.fulfilled, (state, action) => {
            state.loading = false
            state.userSubscription = action.payload
        })
        .addCase(getUserSubscription.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(buySubscription.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(buySubscription.fulfilled, (state, action) => {
            state.loading = false
            state.resData = action.payload
          // state.redirect = action.payload?.url
          window.open( action.payload?.url, "_blank", "noopener,noreferrer")

        })
        .addCase(buySubscription.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(cancelSubscription.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(cancelSubscription.fulfilled, (state, action) => {
            state.loading = false
            state.resData = action.payload
            state.message='Subscription Canceled'
          

        })
        .addCase(cancelSubscription.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(resumeSubscription.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(resumeSubscription.fulfilled, (state, action) => {
            state.loading = false
            state.resData = action.payload
           // state.redirect = action.payload?.url

        })
        .addCase(resumeSubscription.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        
       
       
    }
});


export default subscriptionSlice.reducer;